<div>
  <ng-template #dialerPanel>
    <div
      class="fixed inset-0 sm:static sm:inset-auto flex flex-col overflow-hidden right-10 m-1 dialer-container pointer-events-auto"
      cdkDrag
      cdkDragBoundary=".cdk-overlay-container"
      #dragger
      [cdkDragFreeDragPosition]="dragPosition"
      (cdkDragEnded)="onDragEnd($event)"
      [ngClass]="{
        'minified-container': isZuperConnectMinimized,
        'light-themed': isZuperConnectMinimized ? false : isLightThemed
      }"
    >
      @if (integrations['zuperconnect']) {
        <div
          class="zuper-connect-container"
          id="zuper-connect-container"
          [ngClass]="isZuperConnectMinimized ? 'zuper-connect-minify' : ''"
        >
          @if (!isZuperConnectMinimized) {
            <div class="zuper-connect-dragger cursor-move w-full">
              <div class="grid w-full h-12" [ngClass]="isContextualDisplayOpen ? 'grid-cols-2' : 'grid-cols-1'">
                @if (isContextualDisplayOpen && isSideKickEnabled) {
                  <div class="flex justify-between relative px-3 items-center">
                    <span class="min-h-5 min-w-5 h-5 text-lg text-white">
                      Sidekick <span class="text-md">(Beta)</span>
                    </span>
                  </div>
                }
                <div class="flex justify-between relative px-3 items-center">
                  @if ((onCall || onCalling) && (isCallFromCustomer || isCallToCustomer) && isSideKickEnabled) {
                    <span
                      class="min-h-5 min-w-5 h-5 w-5 text-xl cursor-pointer text-white rounded-md zuper-connect-action-icon"
                      (click)="toggleContextualDisplay()"
                    >
                      <em class="ti" [ngClass]="isContextualDisplayOpen ? 'ti-layout-sidebar-right-collapse' : 'ti-layout-sidebar-right'"></em>
                    </span>
                  }
                  <span class="min-h-5 min-w-5 h-5 text-l text-white">
                    {{ (isCallFromCustomer || isCallToCustomer) ? ('') : 'Zuper Connect' }}
                  </span>
                  <span
                    class="text-xl cursor-pointer text-white rounded-md zuper-connect-action-icon text-center"
                    [class.animate-pulse]="isNotIntraction"
                    (click)="hideOrMinimizeZuperConnectFrame()"
                  >
                    <em class="ti" [ngClass]="onCall || onCalling ? 'ti-arrows-diagonal-minimize' : 'ti-minus'"></em>
                  </span>
                </div>
              </div>
            </div>
          }
          @if (zuperConnectUrl) {
            <iframe
              #zuperConnectIframe
              id="zuper-connect-frame"
              title="zuper-connect-frame"
              class="zuper-connect-iframe"
              allow="microphone"
              [src]="zuperConnectUrl"
              [ngClass]="isContextualDisplayOpen ? 'contextual-display' : ''"
            ></iframe>
          }
        </div>
      } @else {
        <div class="other-dialer-container">
          @if (!isZuperConnectMinimized) {
            <div class="dialer-dragger flex justify-end relative h-8 w-full px-3 py-1.5 bg-white cursor-move">
              <span
                class="min-h-5 min-w-5 h-5 w-5 text-xl cursor-pointer zuper-connect-action-icon"
                (click)="hideOrMinimizeZuperConnectFrame()"
              >
                <em class="ti" [ngClass]="onCall || onCalling ? 'ti-minimize' : 'ti-minus'"></em>
              </span>
            </div>
          }
          @if (integrations[integratedDialerPluginNames.aircall]) {
            <div class="aircall-container" id="aircall-container"></div>
          }
          @if (integrations[integratedDialerPluginNames.ringcentral]) {
            <div class="ring-central-container" id="ring-central-container">
              <iframe
                #ringCentralIframe
                id="ring-central-frame"
                title="ring-central-frame"
                class="ring-central-iframe"
                allow="microphone"
                src="https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/app.html"
              ></iframe>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</div>
